// src/types/index.ts

export interface Application {
  id?: string;
  studentId: string;
  studentEmail: string;
  fullName: string;
  studentFaculty: string;
  businessCategory: string;
  specificCategory?: string;
  businessName: string;
  businessLogo: string;
  registrationDate: string;
  status: Status;
  observations?: string;
  businessURL: string;
}

export enum Status {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

export interface FormState {
  studentId: string;
  studentEmail: string;
  fullName: string;
  studentFaculty: string;
  businessCategory: string;
  specificCategory?: string;
  businessName: string;
  businessLogo: File | null;
  businessURL: string;
}

export interface Business {
  name: string;
  logo: string;
}

export const BlankApplication: Application = {
  id: "",
  studentId: "",
  studentEmail: "",
  fullName: "",
  studentFaculty: "",
  businessCategory: "",
  specificCategory: "",
  businessName: "",
  businessLogo: "",
  registrationDate: "",
  status: Status.Pending,
  observations: "",
  businessURL: "",
};

export const BlankFormState: FormState = {
  studentId: "",
  studentEmail: "",
  fullName: "",
  studentFaculty: "",
  businessCategory: "",
  specificCategory: "",
  businessName: "",
  businessLogo: null,
  businessURL: "",
};

export interface User {
  id: string;
  email: string;
  name: string;
  role: "super_admin" | "evaluator" | "viewer";
  created_at?: string;
  last_login?: string;
}

export const BlankUser: User = {
  id: "",
  email: "",
  name: "",
  role: "viewer",
};
